module.exports = __webpack_public_path__ + "static/media/farmacie.644c455a.png";